/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Show_PasswordInputs */

const es_cap_show_password = /** @type {(inputs: Cap_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar contraseña`)
};

const gl_cap_show_password = /** @type {(inputs: Cap_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar contrasinal`)
};

const en_cap_show_password = /** @type {(inputs: Cap_Show_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

/**
* | output |
* | --- |
* | "Show password" |
*
* @param {Cap_Show_PasswordInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_show_password = /** @type {((inputs?: Cap_Show_PasswordInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Show_PasswordInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_show_password(inputs)
	if (locale === "en") return en_cap_show_password(inputs)
	return es_cap_show_password(inputs)
});